import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { CONFIG_VARS } from "../../constants/configuration";

const { baseUrl, apiVersion } = CONFIG_VARS;

export const LSQ_ACTIVITY_CODES = {
  STUDENT_REGISTRATION: 345,
  SCHOOL_REGISTRATION: 219,
  BROCHURE_DOWNLOAD: 218
};

export const geniusMarketingApi = createApi({
  reducerPath: "geniusMarketingApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl?.["1"] || "",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth?.tokens?.access_token;
      if (token) headers.set("Authorization", `${token}`);
      headers.set("accept", "application/json");
      headers.set("product-id", "100");
      headers.set("tenant-id", "99999");
      return headers;
    }
  }),
  endpoints: (build) => ({
    geniusLsqActivity: build.mutation({
      query: (body) => ({
        url: `${apiVersion}/lsq/genius-activity`,
        method: "POST",
        body
      })
    })
  })
});

export const { useGeniusLsqActivityMutation } = geniusMarketingApi;
